import { ExpandMore } from '@mui/icons-material';
import { Button, Grid, Menu, MenuItem, Typography, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { getRequiredReviewPreference, postRequiredReviewPreference } from '../../../../../api/facility';
import Iconify from '../../../../../reusable-components/iconify';
import { useSnackbar } from '../../../../../reusable-components/snackbar';

RequiredOptions.propTypes = {
  facilityId: PropTypes.number,
};
export default function RequiredOptions({ facilityId }) {
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = async (newValue) => {
    setValue(newValue);
    setLoading(true);
    const result = await postRequiredReviewPreference(facilityId, newValue);
    if (result.status === 200)
      enqueueSnackbar(result.data.message, { variant: 'success' });
    else
      enqueueSnackbar('There was an error changing the required preference', { variant: 'error' });
    setLoading(false);
  }

  const getData = async () => {
    const res = await getRequiredReviewPreference(facilityId);
    setValue(res.data || "All");
  }

  useEffect(() => {
    getData();
  }, [])

  return (
    <Grid container alignItems="center">
      <Iconify icon={'lsicon:order-done-filled'} width={18} height={18} color="info" sx={{ mb: 0.5, mr: 1 }} />
      <Typography> Approve order if
        <Button size="small" color="info" endIcon={<ExpandMore />} disabled={loading} onClick={handleClick}>
          {loading ? <CircularProgress color="info" size={14} /> : (value || 'All')}
        </Button>
        required reviewer approves
      </Typography>
      <Menu
        id="basic-menu-2-b"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'Required-Option-Menu-Button' }}
      >
        <MenuItem dense onClick={() => { handleChange("Any"); handleClose(); }}>Any</MenuItem>
        <MenuItem dense onClick={() => { handleChange("All"); handleClose(); }}>All</MenuItem>
      </Menu>
    </Grid>
  )
}

